export const SET_ACTIVE_SECTION = 'Dashboard/Statistics/SET_ACTIVE_SECTION';
export const LOAD_STATISTICS = 'LOAD_STATISTICS';
export const SET_STATISTICS = 'SET_STATISTICS';

export const MONTH_SIGNUPS = 'MONTH_SIGNUPS';
export const YEAR_SIGNUPS = 'YEAR_SIGNUPS';
export const TOP_COMMISSIONS = 'TOP_COMMISSIONS';

export const setStatistics = (userStats, commissionStats) => ({
  type: SET_STATISTICS,
  userStats,
  commissionStats
});
export const loadStatistics = () => ({
  type: LOAD_STATISTICS
});

export const setActiveSection = section => ({
  type: SET_ACTIVE_SECTION,
  section
});

const initialState = {
  activeSection: MONTH_SIGNUPS,
  loading: true
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_SECTION:
      return {
        ...state,
        activeSection: action.section
      };
    case SET_STATISTICS:
      return {
        ...state,
        loading: false,
        monthSignups: action.userStats.monthly_stats,
        yearSignups: action.userStats.yearly_stats,
        commissions: action.commissionStats,
        month: action.userStats.month,
        year: action.userStats.year
      };
    default:
      return state;
  }
};
